import { CacheRepository } from './iCacheRepository';
import { CookieCache } from './cookieCache';
import { DictCache } from './dictCache';
import { CacheKeys } from './cacheKeys';
import consoleLogger from '../logger/consoleLogger';
import { LocalStorageCache } from './localStorageCache';

const logger = consoleLogger.getPrefixedCopy('KVCACHE');

export class KVCache implements CacheRepository {
    private static instance: KVCache;

    private repo: CacheRepository;

    private constructor() {
        this.repo = this.getCachingMechanism();
    }

    public static getInstance() {
        if (typeof this.instance === 'undefined') {
            this.instance = new KVCache();
        }

        return this.instance;
    }


    public get<T>(key: CacheKeys): T {
        return this.repo.get(key);
    }

    public set<T>(key: CacheKeys, value: T): boolean {
        return this.repo.set(key, value);
    }

    public delete(key: CacheKeys): boolean {
        return this.repo.delete(key);
    }

    private getCachingMechanism(): CacheRepository {
        let localStorageEnabled;
        let cookieEnabled;

        try {
            localStorageEnabled = window?.localStorage ?? false;
        } catch (error) {
            console.error(`LocalStorage unavailable: ${(<Error>error).message}`);
        }

        if (localStorageEnabled) {
            logger.info('init local storage cache');
            return new LocalStorageCache();
        }

        cookieEnabled = window?.navigator?.cookieEnabled ?? false;

        if (cookieEnabled) {
            logger.info('init cookie cache');
            return new CookieCache();
        }

        logger.warning('init non persistant cache');
        window.Sentry.captureMessage('DictCache chosen');
        return new DictCache();
    }
}
